import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=3b641a07"
import script from "./Prescription.vue?vue&type=script&lang=js"
export * from "./Prescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports